import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'src/app/services/global.service';
import { NewfolderService } from 'src/app/services/newfolder.service';
import { format } from 'url';





@Component({
  selector: 'app-newfolder',
  templateUrl: './newfolder.component.html',
  styleUrls: ['./newfolder.component.css']
})
export class NewfolderComponent implements OnInit {

  //string
  token: string;
  nameGroup: string = '';
  changeNameFolder: string;
  folder: string = 'Cartella senza nome';

  //array
  group: Array<any> = [];
  groupAdd: Array<any> = [];
  customer: Array<any> = [];
  customerF: Array<any> = [];
  customerG: Array<any> = [];
  groupAddF: Array<any> = [];
  groupAddG: Array<any> = [];
  groupAddGrp: Array<any> = [];

  //boolean
  check: boolean
  newGroup = false;
  changeFolderName = false;
  changed = false;
  other = true;
  permits: boolean = false;

  //number
  i: number = 1;

  //Input
  @Input() folderName;
  @Input() folderID;

  constructor(
    private modalService: NgbModal,
    private globals: GlobalService,
    public activeModal: NgbActiveModal,
    public newfolderService: NewfolderService,
  ) {
    $(document).ready(function () {
      $("#FolderName").focus();
      $(":focus").select();
    });
  }

  ngOnInit() {
    if (!this.token) {
      this.token = this.globals.getToken();
    }
    this.getGroups();
    this.getCustomer();
    // this.setList()
  }

  getCustomer() {
    this.newfolderService.getCustomer(this.token).subscribe(
      res => {
        this.customer = res;
        this.customer.forEach((element, k) => {
          if (element.type == "F") {
            this.customerF.push(this.customer[k])
          } else {
            this.customerG.push(this.customer[k])
          }
        });
      },
      err => {
        console.error("Errore in getOperators", err);

      }
    )
  }

  getGroups() {
    this.newfolderService.getGroups(this.token).subscribe(
      res => {
        this.group = res;
        this.group.forEach(grp => {
          grp.select = false;
        })
      },
      err => {
        console.error("Errori in getGroups: ", err);
      }
    )
  }

  permitsFunc() {
    if (this.permits) {
      this.permits = false;
    } else {
      this.permits = true;
    }

  }

  canceling() {
    this.activeModal.close('cancel');
  }

  updateFolder() {
    if (this.changed == true) {
      this.newfolderService.newFolder(this.token, this.folderID, this.folderName).subscribe(
        res => {
          if (this.groupAdd.length > 0) {
            let obj: any;
            obj = {
              auth: [],
              inherited: false
            }
            this.groupAdd.forEach(element => {
              obj.auth.push({
                authorityId: element.alfresco_id,
                name: "Contributor",
                accessStatus: "ALLOWED",
              })
            });
            let id: string = res.id
            this.newfolderService.setPermission(this.token, obj, id).subscribe(
              res => {
              },
              err => {
                console.error("Errore in setPermission: ", err);
              }
            )
          }
          this.activeModal.close();
        },
        err => {
          console.error("Errore in addFolder: ", err);
        }
      )
    }
  }

  addFolder() {
    if (this.folder != 'Cartella senza nome' && this.folder != '') {
      this.newfolderService.newFolder(this.token, this.folderID, this.folder).subscribe(
        res => {
          if (this.groupAdd.length > 0) {
            let obj: any;
            obj = {
              auth: [],
              inherited: false
            }
            this.groupAdd.forEach(element => {
              obj.auth.push({
                authorityId: element.alfresco_id,
                name: "Contributor",
                accessStatus: "ALLOWED",
              })
            });
            let id: string = res.id
            this.newfolderService.setPermission(this.token, obj, id).subscribe(
              res => {
              },
              err => {
                console.error("Errore in setPermission: ", err);
              }
            )
          }
          this.activeModal.close();
        },
        err => {
          console.error("Errore in addFolder: ", err);
        }
      )
    } else {
      alert("Nome cartella non valido")
    }
  }

  push(add) {

    let control: boolean = false

    if (add) {

      if (add.customer_id) {
        this.groupAddF.forEach(cus => {
          if (cus.customer_id == add.customer_id) {
            control = true;
          }
        });
      }

      if (add.customer_id) {
        this.groupAddG.forEach(cus => {
          if (cus.customer_id == add.customer_id) {
            control = true;
          }
        });
      }

      if (add.group_id) {
        this.groupAddGrp.forEach(grp => {
          if (grp.group_id == add.group_id) {
            control = true;
          }
        });
      }

      if (control == false) {
        this.groupAdd.push(add)
        if (add.name) {
          this.groupAddF.push(add);
        }
        if (add.business_name) {
          this.groupAddG.push(add);
        }
        if (add.group_name) {
          this.groupAddGrp.push(add);
        }
      } else {
        alert("il profilo selezionato è già stato inserito nella lista")
      }
    } else {
      alert("Seleziona un profilo")
    }


  }

  add() {
    if (!this.newGroup) {
      this.newGroup = true;
    } else
      this.newGroup = false;
  }

  addGroup() {
    if (this.nameGroup) {
      let obj = {
        group: {
          group_name: this.nameGroup
        },
        customers: []
      }
      this.newfolderService.newGroup(this.token, obj).subscribe(
        res => {
          this.getGroups();
          this.newGroup = false;
          this.nameGroup = ''
        }, err => {
          console.error("Errore in addGroup: ", err);
        }
      )
    } else {
      alert("Inserisci il nome del gruppo")
    }
  }

  smista() {
    this.groupAdd.forEach(element => {
      if (element.name) {
        this.groupAddF.push(element);
      }

      if (element.business_name) {
        this.groupAddG.push(element);
      }

      if (element.group_name) {
        this.groupAddGrp.push(element);
      }
    });
  }

  change() {
    if (this.i == 1) {
      this.changeNameFolder = this.folderName;
      this.i = 10
    }
    if (this.changed == false) {
      this.changed = true;
    } else {
      this.changed = false;
    }
  }

}